import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CastRes from "types/res/cast/CastRes";
import CastApi from "api/CastApi";
import LineApi from "api/LineApi";
import {
  Box,
  Button,
  createStyles,
  Divider,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { changeAccount } from "redux/actions/account";
import { useHistory } from "react-router-dom";
import { Alert } from "@material-ui/lab";
const Setting = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const company = useSelector((state: any) => state.account.cast.company);
  const email = useSelector((state: any) => state.account.cast.email);
  const castId = useSelector((state: any) => state.account.cast.castId);
  const [castList, setCastList] = useState<CastRes[]>([]);
  const [lineUserId, setLineUserId] = useState("");
  const [notifyMethod, setNotifyMethod] = useState("email");
  const [isLinked, setIsLinked] = useState(false);
  const [lineSaved, setLineSaved] = useState(false);
  const useStyles = makeStyles(() =>
    createStyles({
      button: {},
    })
  );
  const classes = useStyles();
  useEffect(() => {
    const apiCall = async () => {
      const result = await CastApi.findByEmail(email);
      setCastList(result);
    };
    apiCall();
  }, []);
  useEffect(() => {
    const fetchLineStatus = async () => {
      try {
        const result: any = await LineApi.getStatus(castId);
        if (result) {
          setLineUserId(result.lineUserId || "");
          setNotifyMethod(result.notifyMethod || "email");
          setIsLinked(!!result.lineUserId);
        }
      } catch (e) {
        console.error(e);
      }
    };
    if (castId) fetchLineStatus();
  }, [castId]);
  const onClickChangeAccount = (cast: CastRes) => {
    dispatch(changeAccount({ cast }));
  };
  const handleLineSave = async () => {
    try {
      if (lineUserId) {
        await LineApi.link(castId, lineUserId);
      } else {
        await LineApi.unlink(castId);
      }
      await LineApi.updateNotifyMethod(castId, notifyMethod);
      setIsLinked(!!lineUserId);
      setLineSaved(true);
      setTimeout(() => setLineSaved(false), 3000);
    } catch (e) {
      alert("LINE設定の保存に失敗しました");
    }
  };
  return (
    <Box display="flex" flexDirection="column">
      <Box margin={2}>
        <Typography>現在のログイン中企業：{company.name}</Typography>
      </Box>
      <Divider />
      <Box display="flex" flexDirection="column" margin={2}>
        <Typography variant={"subtitle1"}>所属企業一覧</Typography>
        {castList.map((cast, idx) => (
          <Box
            key={idx}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            marginY={1}
          >
            <Typography>{cast.company.name}</Typography>
            <Button
              variant="contained"
              className={classes.button}
              color="secondary"
              onClick={() => onClickChangeAccount(cast)}
            >
              <Typography>切り替え</Typography>
            </Button>
          </Box>
        ))}
      </Box>
      <Divider />
      <Box display="flex" flexDirection="column" margin={2}>
        <Typography variant={"subtitle1"}>LINE連携</Typography>
        <Box marginTop={1}>
          <Typography variant="body2" color="textSecondary">
            {isLinked ? "✅ LINE連携済み" : "❌ LINE未連携"}
          </Typography>
        </Box>
        <Box marginTop={2}>
          <TextField
            fullWidth
            label="LINE ユーザーID"
            value={lineUserId}
            onChange={(e) => setLineUserId(e.target.value)}
            variant="outlined"
            size="small"
            placeholder="Uxxxxxxxxx..."
          />
        </Box>
        <Box marginTop={2}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>通知方式</InputLabel>
            <Select
              value={notifyMethod}
              onChange={(e) => setNotifyMethod(e.target.value as string)}
              label="通知方式"
            >
              <MenuItem value="email">メールのみ</MenuItem>
              <MenuItem value="line">LINEのみ</MenuItem>
              <MenuItem value="both">メール+LINE</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box marginTop={2} display="flex" alignItems="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleLineSave}
          >
            LINE設定を保存
          </Button>
          {lineSaved && (
            <Typography style={{ marginLeft: 16, color: "green" }}>
              保存しました
            </Typography>
          )}
        </Box>
      </Box>
      <Divider />
      <Box marginTop={2} display={"flex"} justifyContent={"center"}>
        <Alert severity={"error"}>
          企業が追加された方は一度ログアウトし、パスワードリセットを行ってください
        </Alert>
      </Box>
      <Box marginTop={2} display={"flex"} justifyContent={"center"}>
        <Button
          variant="contained"
          className={classes.button}
          color="default"
          onClick={() => history.push("/")}
        >
          トップページへ
        </Button>
      </Box>
    </Box>
  );
};

export default Setting;
